<template lang="pug">
.chart
    highcharts(:options="chartOptions")
</template>

<script>

export default {
    name: 'Chart',
    data() {
        return {
            title: '',
            points: [10, 0, 8, 2, 6, 4, 5, 5],
            chartType: 'Spline',
            seriesColor: '#6fcd98',
            colorInputIsSupported: null,
            chartOptions: {
                chart: {
                    type: 'spline'
                },
                title: {
                    text: 'Sin chart'
                },
                series: [{
                    data: [10, 0, 8, 2, 6, 4, 5, 5],
                    color: '#6fcd98'
                }]
            }
        }
    },
}
</script>

<style lang="sass">

</style>
